// El desglose de un corte cerrado llega sin las listas vacías: se leen con su valor vacío.
export function orEmpty<T>(list: readonly T[] | undefined): readonly T[] {
    return list ?? [];
}
